import React, { useRef, useState } from "react"
import IconWithText from "../Atoms/IconWithText"
import { StarsWithPeople } from "../Stars/Stars"
import { navigate } from "gatsby"
import {
  Container,
  ImageWrapper,
  ImageContainer,
  MainContainer,
  Title,
  GlobalRow,
  SubTitle,
  EndContainer,
  Icon,
  Price,
  Text,
  Button,
  ButtonOutline,
  Row,
} from "./styles/ExpandedCard.styles"

import { useDispatch } from "react-redux"
import { openModal } from "../../redux/layoutSlice"
import navigateToChirurgo from "../../functions/navigateToChirurgo"

export default function ExpandedCard({ doctor, ...restProps }) {
  const dispatch = useDispatch()
  return (
    <Container {...restProps}>
      <ImageWrapper>
        <ImageContainer
          onClick={() => navigateToChirurgo(doctor)}
          img={doctor.url_foto}
        />
      </ImageWrapper>
      <MainContainer>
        <Title onClick={() => navigateToChirurgo(doctor)}>{doctor.nome}</Title>
        <SubTitle>{doctor.specializzazione}</SubTitle>

        <StarsWithPeople
          fontSize={11}
          count={doctor.rating}
          people={doctor.reviews_count}
          style={{ marginTop: -15 }}
        />

        <GlobalRow>
          <Icon src={require("../../images/pin.png")} />
          <Text> {doctor.list_provincie}</Text>
        </GlobalRow>
        <GlobalRow style={{ marginTop: "auto", marginBottom: -10 }}>
          {doctor.count_foto > 0 && (
            <IconWithText
              onClick={() => navigateToChirurgo(doctor, "#prepost")}
              img={require("../../images/Camera.png")}
              number={doctor.count_foto}
            />
          )}
          <div style={{ width: 10 }} />
          {doctor.count_video > 0 && (
            <IconWithText
              onClick={() => navigateToChirurgo(doctor, "#video")}
              img={require("../../images/video.png")}
              number={doctor.count_video}
            />
          )}
        </GlobalRow>
        {doctor.hasVideCon && (
          <GlobalRow>
            <Icon
              style={{ height: 14 }}
              src={require("../../images/videocon.png")}
            />
            <Text style={{ color: "#1e75e8" }}>
              {" "}
              Videoconsulto online disponibile
            </Text>
          </GlobalRow>
        )}
      </MainContainer>
      <EndContainer>
        {doctor.prima_visita_gratuita == 0 ? (
        <Row>
         <Text>Prima visita</Text>
         <Price>{doctor.prezzo_prima_visita} €</Price>
        </Row>
        ) : (
          <Row>
           <Text>Prima visita gratuita</Text>
          </Row>
          )}
        {doctor.finanziamenti > 0 && (
          <Text style={{ color: "#1e75e8" }}>Finanziamento disponibile</Text>
        )}
        <ButtonOutline onClick={() => navigateToChirurgo(doctor)}>
          Scheda
        </ButtonOutline>
        <Button onClick={() => dispatch(openModal(doctor))}>Contatta</Button>
      </EndContainer>
    </Container>
  )
}
